export const stateRouteMapping = {
    initiated: "language",
    language_captured: "addressVerification",
    selfie_captured: "idProof",
    id_proof_captured: "idPhoto",
    photo_with_id_captured: "addressProof",
    address_proof_captured: "video",
    home_video_captured: "preview",
    user_submitted: "thankyou"
}

export const stateRouteMappingV2 = {
    initiated: "language",
    language_captured: "addressVerification",
    selfie_captured: "idProof",
    id_proof_captured: "idPhoto",
    photo_with_id_captured: "addressProof",
    address_proof_captured: "homeImage",
    home_image_captured: "video",
    home_video_captured: "preview",
    user_submitted: "thankyou"
}